import { AlertsSection } from './AlertsSection';
import { createCarrierAlerts } from './createCarrierAlerts';

export const SystemAlerts = () => {
  const alerts = createCarrierAlerts();

  return (
    <AlertsSection
      heading="Carrier Alerts"
      sectionTitle="System Alerts"
      alerts={alerts()}
      dataTestId="carrier-system-alerts"
    />
  );
};
